module.exports = __webpack_public_path__ + "img/coupon-popup-item-use.2d5285de.png";